"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getOperations = void 0;
var bignumber_js_1 = require("bignumber.js");
var network_1 = __importDefault(require("../../../network"));
var env_1 = require("../../../env");
var operation_1 = require("../../../operation");
var DEFAULT_TRANSACTIONS_LIMIT = 100;
var getIndexerUrl = function (route) {
    return "".concat((0, env_1.getEnv)("API_NEAR_INDEXER")).concat(route || "");
};
var fetchTransactions = function (address, limit) {
    if (limit === void 0) { limit = DEFAULT_TRANSACTIONS_LIMIT; }
    return __awaiter(void 0, void 0, void 0, function () {
        var route, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    route = "/transactions?limit=".concat(limit, "&account=").concat(address, "&date=").concat(new Date().getTime());
                    return [4 /*yield*/, (0, network_1["default"])({
                            method: "GET",
                            url: getIndexerUrl(route)
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, (data === null || data === void 0 ? void 0 : data.records) || []];
            }
        });
    });
};
function isSender(transaction, address) {
    return transaction.sender === address;
}
function getOperationType(transaction, address) {
    var _a, _b;
    switch ((_b = (_a = transaction.actions[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.method_name) {
        case "deposit_and_stake":
            return "STAKE";
        case "unstake":
        case "unstake_all":
            return "UNSTAKE";
        case "withdraw":
        case "withdraw_all":
            return "WITHDRAW_UNSTAKED";
        default:
            return isSender(transaction, address) ? "OUT" : "IN";
    }
}
function getOperationValue(transaction, type) {
    var amount = transaction.actions[0].data.deposit || 0;
    if (type === "OUT") {
        return new bignumber_js_1.BigNumber(amount).plus(transaction.fee);
    }
    return new bignumber_js_1.BigNumber(amount);
}
function transactionToOperation(accountId, address, transaction) {
    return __awaiter(this, void 0, void 0, function () {
        var type;
        return __generator(this, function (_a) {
            type = getOperationType(transaction, address);
            return [2 /*return*/, {
                    id: (0, operation_1.encodeOperationId)(accountId, transaction.hash, type),
                    accountId: accountId,
                    fee: new bignumber_js_1.BigNumber(transaction.fee || 0),
                    value: getOperationValue(transaction, type),
                    type: type,
                    hash: transaction.hash,
                    blockHash: transaction.block_hash,
                    blockHeight: transaction.height,
                    date: new Date(transaction.time),
                    extra: {},
                    senders: transaction.sender ? [transaction.sender] : [],
                    recipients: transaction.receiver ? [transaction.receiver] : [],
                    hasFailed: !transaction.success
                }];
        });
    });
}
var getOperations = function (accountId, address) { return __awaiter(void 0, void 0, void 0, function () {
    var rawTransactions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchTransactions(address)];
            case 1:
                rawTransactions = _a.sent();
                return [4 /*yield*/, Promise.all(rawTransactions.map(function (transaction) {
                        return transactionToOperation(accountId, address, transaction);
                    }))];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.getOperations = getOperations;
//# sourceMappingURL=datahub-indexer-sdk.js.map